import { ReactNode, useState } from 'react';

import { defaultFiscalYearEnd, initialCUData } from '@/constants';
import { BusinessDataContext } from '@/context';
import { CUDataType } from '@/types/providers';

export const BusinessDataProvider = ({ children }: { children: ReactNode }) => {
  const [isLeague, setIsLeague] = useState(false);
  const [cuData, setCUData] = useState<CUDataType>(initialCUData);

  const providerData = {
    defaultFiscalYearEnd,
    isLeague,
    setIsLeague,
    cuData,
    setCUData,
  };

  return <BusinessDataContext.Provider value={providerData}>{children}</BusinessDataContext.Provider>;
};
